import React, { Component } from 'react';
import css from './xpa.css';

class BankFeedResponse extends Component {

    render() {
        const errorCode = this.props.match.params.error;

        if (errorCode === 'existing') {
            return (
                <div>
                    <div className={[css.width400, css.center].join(' ')}>
                        <div className={[css.borderBox, css.smallFont].join(' ')}>
                            This Paypal Account is already linked to one of your Reckon books. You will need to delete that existing feed before you can link this account again.
                        </div>
                    </div>
                </div>
            );
        }

        if (errorCode === 'error') {
            return (
                <div>
                    <div className={[css.width400, css.center].join(' ')}>
                        <div className={[css.borderBox, css.smallFont].join(' ')}>
                            An error occurred when creating your feed please try again later.
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className={[css.width400, css.center].join(' ')}>
                    <div className={[css.borderBox, css.smallFont].join(' ')}>
                        Your feeds have been created close this tab to return to the 'Bank feed management Page' where you will see your created feed in the feed list.
                    </div>
                </div>
            </div>
        );
    }
}

export default BankFeedResponse;


// WEBPACK FOOTER //
// ./src/components/XPA/BankFeedResponse.js